module.exports = __webpack_public_path__ + "static/img/amg-2.635bbed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/amg-2.jpg
// module id = /2c0
// module chunks = 1